// Metadata for the admin "Seções / Layout da Página" tool and the public renderer.
// Original (system) sections cannot be deleted, only disabled.

export const SECTION_TYPE = {
  categories: "categories",
  banners: "banners",
  promotions: "promotions",
  coupons: "coupons",
  featured_businesses: "businesses",
  featured_products: "products",
  all_businesses: "businesses",
  services: "services",
  news: "news",
  events: "events",
  tourist_spots: "tourist_spots",
  jobs: "jobs",
  rentals: "rentals",
  commercial_spots: "commercial_spots",
  reels: "reels",
};

export const DEFAULT_TITLES = {
  categories: "Categorias",
  banners: "Banners",
  promotions: "Promoções",
  coupons: "Cupons de Desconto",
  featured_businesses: "Empresas em Destaque",
  featured_products: "Produtos em Destaque",
  all_businesses: "Todas as Empresas",
  services: "Serviços",
  news: "Últimas Notícias",
  events: "Eventos em Pocinhos",
  tourist_spots: "Pontos Turísticos",
  jobs: "Vagas de Emprego",
  rentals: "Casas para Alugar",
  commercial_spots: "Pontos Comerciais",
  reels: "Reels",
};

export const TYPE_LABELS = {
  businesses: "Empresas",
  services: "Serviços",
  products: "Produtos",
  promotions: "Promoções",
  coupons: "Cupons",
  news: "Notícias",
  events: "Eventos",
  tourist_spots: "Pontos Turísticos",
  jobs: "Vagas",
  rentals: "Casas para Alugar",
  commercial_spots: "Pontos Comerciais",
  categories: "Categorias",
  banners: "Banners",
  reels: "Reels (vídeos)",
};

const COMMON = [
  { value: "carousel", label: "Carrossel horizontal" },
  { value: "grid", label: "Grade (vários cards)" },
  { value: "grid2", label: "Grade 2 colunas" },
  { value: "list", label: "Lista vertical" },
];

export const TYPE_VARIANTS = {
  businesses: [
    ...COMMON,
    { value: "image_only", label: "Somente imagem, nome e categoria" },
    { value: "compact", label: "Cards compactos" },
  ],
  services: [...COMMON, { value: "compact", label: "Cards compactos" }],
  products: [...COMMON],
  news: [
    { value: "featured", label: "Notícia principal + menores" },
    ...COMMON,
    { value: "horizontal", label: "Cards horizontais" },
  ],
  coupons: [...COMMON],
  promotions: [...COMMON],
  events: [...COMMON],
  tourist_spots: [...COMMON],
  jobs: [...COMMON],
  rentals: [...COMMON],
  commercial_spots: [...COMMON],
  categories: [{ value: "carousel", label: "Carrossel horizontal" }],
  banners: [{ value: "carousel", label: "Carrossel" }],
  reels: [
    { value: "carousel", label: "Carrossel horizontal" },
    { value: "grid", label: "Grade (vários vídeos)" },
  ],
};

export const DEFAULT_VARIANT = {
  categories: "carousel",
  banners: "carousel",
  promotions: "carousel",
  coupons: "carousel",
  featured_businesses: "carousel",
  featured_products: "carousel",
  all_businesses: "grid",
  services: "grid",
  news: "grid",
  events: "grid",
  tourist_spots: "carousel",
  jobs: "grid",
  rentals: "grid",
  commercial_spots: "grid",
  reels: "carousel",
};

export const DEFAULT_VARIANT_BY_TYPE = {
  businesses: "grid",
  services: "grid",
  products: "carousel",
  promotions: "carousel",
  coupons: "carousel",
  news: "grid",
  events: "grid",
  tourist_spots: "carousel",
  jobs: "grid",
  rentals: "grid",
  commercial_spots: "grid",
  reels: "carousel",
};

export const DOTS_DEFAULTS = {
  enabled: true, shape: "circle", style: "filled", position: "below",
  size: 8, spacing: 6, color: "#CBD5E1", active_color: "", active_grow: true,
};

export const REELS_DEFAULTS = {
  format: "9:16", thumb_size: "md", count: 10, sort: "order", featured_only: false,
  show_titles: true, autoplay_preview: false, menu_enabled: true, show_on_business: true,
};

// Content types the admin can pick when adding a NEW custom section
export const ADDABLE_TYPES = [
  "businesses", "services", "products", "promotions", "coupons", "news",
  "events", "tourist_spots", "jobs", "rentals", "commercial_spots", "reels",
];

export const variantsForSection = (section) => {
  const type = section.type || SECTION_TYPE[section.key] || "businesses";
  return TYPE_VARIANTS[type] || COMMON;
};

export const isOriginalSection = (section) => !section.custom;
